import { render, staticRenderFns } from "./AppSide.vue?vue&type=template&id=f2461c5e"
import script from "./AppSide.vue?vue&type=script&lang=js"
export * from "./AppSide.vue?vue&type=script&lang=js"
import style0 from "./AppSide.vue?vue&type=style&index=0&id=f2461c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports